import { useEffect, useRef, useState } from 'react';

// Animates 0 → `value` (ease-out, rAF). Honors prefers-reduced-motion.
const useCountUp = (value, { duration = 900, enabled = true } = {}) => {
  const [display, setDisplay] = useState(enabled ? 0 : value);
  const frameRef = useRef();

  useEffect(() => {
    if (!enabled || value == null || Number.isNaN(value)) {
      setDisplay(value);
      return;
    }

    const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
    if (prefersReducedMotion) {
      setDisplay(value);
      return;
    }

    let start;
    const tick = (now) => {
      if (start === undefined) start = now;
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
      setDisplay(value * eased);
      if (progress < 1) frameRef.current = requestAnimationFrame(tick);
    };
    frameRef.current = requestAnimationFrame(tick);

    return () => cancelAnimationFrame(frameRef.current);
  }, [value, duration, enabled]);

  return display;
};

export default useCountUp;
